export const authKeys = {
  all: ['auth'] as const,

  currentUser: () => [...authKeys.all, 'current-user'] as const,
  sessionProbe: () => [...authKeys.all, 'session-probe'] as const,
};
